export function isValidAddressField(value: string) {
  return value.length <= 35 && value.length >= 3;
}

export function isValidEmail(value: string) {
  return new RegExp(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i).test(value)
  && value.length >= 3
  && value.length <= 50;
}

export function isValidTelephone(value: string, isUS: boolean) {
  if (isUS) return value.length === 10 && +value > 0;
  else return value.length >=10 && value.length <= 15 && +value > 0;
}

export function isLessThan10Characters(value: string) {
  return value?.length <= 10;
}

export function isValidPostalCode(value: string, regex: string) {
  return new RegExp(regex).test(value.toUpperCase()) && isLessThan10Characters(value);
}

export function hasPostalCodeRegex(regex: string) {
  return !!regex
    && regex !== 'Country not postcode-format enabled.'
    && regex !== 'Not found in the database of postcode format enabled countries.';
}

export function isBetweenXAndXCharacters(value: string, lowerValue: number, upperValue: number) {
  return value.length >= lowerValue && value.length <= upperValue
}

export function isValidShortAddressCode(value: string) : boolean {
  return new RegExp(/^[A-Z]{4}\d{4}$/i).test(value) && value.length <= 8;
}

export const PID_MAX_LENGTH = 35;
export const PID_PATTERN = /^[A-Za-z0-9\-_./]{1,35}$/;
export const PID_FORMAT_MESSAGE = 'Up to 35 characters: letters, numbers and - _ . /';

export function normalisePid(value?: string): string {
  return value ? value.trim() : '';
}

export function isPidSupplied(value?: string): boolean {
  return normalisePid(value).length > 0;
}

export function isValidPid(value?: string): boolean {
  return !isPidSupplied(value) || PID_PATTERN.test(normalisePid(value));
}
